import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Media3DTourUrlValidationResponse } from '../apimodels/media/media-3d-tour-rul-validation-response';
import { Environment, ENVIRONMENT } from '@classifieds-sell/environment';

@Injectable({
    providedIn: 'root'
})
export class MediaService {
    constructor(
      private httpClient: HttpClient,
      @Inject(ENVIRONMENT) private env: Environment
    ) {}

    validate3DTourUrl(
        url: string
    ): Observable<Media3DTourUrlValidationResponse> {
        return this.httpClient.post<Media3DTourUrlValidationResponse>(
            `${this.env.apiUrl}/Media/3DTourUrl/Validate`,
            { url },
            { withCredentials: true }
        );
    }
}
